import includes from "lodash/includes"
import { Map, List } from "immutable"
import { types } from "../../actions"
import collections from "../collections"

export default function collectionsReducer(state = Map(), action) {
  if (includes(types, action.type)) {
    const { engine, model } = action

    const key = List([engine.name, model.name])

    return state.set(key, collections(state.get(key), action))
  }
  return state
}
